<template>
    <v-flex x12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 class="card-dados__titulo mb-0">Anexos</h3>
        <compra-direta-upload-arquivo ref="azFileUploadAnexo" class="pa-3" :multiple="false"
                        @error="tratarErroEnvioArquivo" @uploadArquivo="tratarEventUploadArquivo" :accept="formatosValidos">
            <a @click.prevent="$refs.azFileUploadAnexo.openFileSelector()">
                <v-icon>archive</v-icon>
                Adicionar Arquivos
            </a>
        </compra-direta-upload-arquivo>

        <v-data-table :headers="colunas" :items="value" :total-items="value.length"
                      :loading="false" no-data-text="Não há arquivos adicionados" hide-actions
                      class="az-table-list table-arquivos-consulta">
            <template slot="items" slot-scope="props">
                <td width="80">
                    <div v-if="situacaoCompraDireta === 'EM_ELABORACAO'">
                        <v-select v-model="props.item.documentoId"
                                  :items="documentosParaSelecao" align="center"
                                  item-text="nome" item-value="id" @change="atualizarTipo(props.item)"/>
                        <span v-if="!props.item.documentoId" class="mensagem-erro">O campo Tipo é obrigatório</span>
                    </div>
                    <div v-if="exibirModoEdicao && !props.item.documentoId" class="selecionar-tipo">
                        <v-select :items="documentosParaSelecao" v-model="props.item.documentoIdTemp" align="center"
                                  item-text="nome" item-value="id"/>
                        <v-tooltip top>
                            <v-btn id="botaoAdicionar" slot="activator" outline flat small color="primary"
                                   :disabled="!props.item.documentoIdTemp" @click="atualizarTipo(props.item)">
                                <v-icon size="20">check</v-icon>
                            </v-btn>
                            Adicionar
                        </v-tooltip>
                        <span v-if="!props.item.documentoIdTemp" class="mensagem-erro">O campo Tipo é obrigatório</span>
                    </div>
                    <span v-if="exibirModoEdicao && props.item.documentoId">{{ props.item.documentoId | documentoFilter(documentos) }}</span>
                </td>
                <td>
                    {{ props.item.criadoEm | az-date(formatosDefault.DATA) }}
                </td>
                <td>
                    {{ props.item.nome }}
                </td>
                <td>
                    {{ props.item.situacao === 'ATIVO' ? 'Ativo' : 'Inativo' }}
                </td>
                <td class="table-actions">
                    <botao-inativar-anexo class="actions-item" :situacaoAtual="props.item.situacao"
                                          v-show="exibirModoEdicao && props.item.documentoId && props.item.situacao === 'ATIVO'"
                                          @inativarAnexo="$emit('atualizarSituacaoAnexo', props.item.id, 'INATIVO')"/>
                    <botao-ativar-anexo class="actions-item" :situacaoAtual="props.item.situacao"
                                        v-show="exibirModoEdicao && props.item.documentoId && props.item.situacao === 'INATIVO'"
                                        @ativarAnexo="$emit('atualizarSituacaoAnexo', props.item.id, 'ATIVO')"/>
                    <botao-download class="actions-item" v-if="deveMostrarBotaoDownload(props.item)" :documento="props.item" @baixarDocumentos="tratarEventDownloadAnexo($event, props.item)"/>
                    <botao-excluir class="actions-item" v-if="situacaoCompraDireta === 'EM_ELABORACAO' || (exibirModoEdicao && !props.item.documentoId)"
                                   @excluir="$emit('excluirAnexo', props.item.id)"/>
                </td>
            </template>
        </v-data-table>
    </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import {AzSoundex} from '@azinformatica/loki'
import CompraDiretaUploadArquivo from '@/views/pages/commons/upload-arquivo/CompraDiretaUploadArquivo'
import {actionTypes} from '@/core/constants'

export default {
    name: 'PainelAnexoEdicao',
    components: {CompraDiretaUploadArquivo},
    inject: ['$validator'],
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        documentos: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        situacaoCompraDireta: {
            type: String,
            default: 'EM_ELABORACAO'
        }
    },
    data() {
        return {
            paginacaoInterna: null,
            colunas: [
                {
                    text: 'Tipo',
                    sortable: true,
                    value: 'tipo',
                    width: '150px',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Data',
                    sortable: true,
                    value: 'criadoEm',
                    width: '50px',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    value: 'nome',
                    text: 'Nome',
                    align: 'left',
                    sortable: true,
                    class: 'primary--text',
                    width: '200px'
                },
                {
                    width: '30px',
                    value: 'situacao',
                    align: 'left',
                    sortable: true,
                    text: 'Situação',
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'center',
                    width: '60px',
                    class: 'primary--text'
                }
            ],
            soundexDocumentos: [],
            taxaSemelhancaMinimaAceitavelTipoAnexo: 5.0,
            formatosValidos: 'application/pdf',
            repository: 'repo1:compradireta',
        }
    },
    computed: {
        ...mapState(['loki']),
        exibirModoEdicao() {
            return ['EM_ANALISE', 'REANALISE', 'ABERTA', 'ENCERRADA', 'AGUARDANDO_ABERTURA'].includes(this.situacaoCompraDireta)
        },
        documentosParaSelecao(){
            return this.documentos.filter(doc => doc.nome !== 'Termo de desentranhamento')
        }
    },
    methods: {
        compraEmAnaliseOuReanalise(){
            return ['EM_ANALISE', 'REANALISE'].includes(this.situacaoCompraDireta)
        },
        atualizarTipo(anexo) {
            if (anexo.documentoIdTemp) {
                anexo.documentoId = anexo.documentoIdTemp
            }
            this.$emit('atualizarTipoAnexo', anexo)
        },
        gerarSoundexParaDocumentos() {
            this.documentos.forEach(documento => {
                const soundex = AzSoundex.gerarSoundex(documento.nome.toLowerCase(), true)
                this.soundexDocumentos.push(soundex)
                documento.soundex = soundex
            })
        },
        inferirTipoAnexo(anexoNome) {
            this.gerarSoundexParaDocumentos()
            const nomeArquivo = this.limparNomeArquivo(anexoNome)
            const soundexNomeArquivo = AzSoundex.gerarSoundex(nomeArquivo.toLowerCase(), true)
            const soundexMaisParecido = AzSoundex.selecionarMaisParecido(this.soundexDocumentos, soundexNomeArquivo)
            if (soundexMaisParecido.bestMatch.rating < this.taxaSemelhancaMinimaAceitavelTipoAnexo) {
                return undefined
            }
            const docEncontrado = this.documentos.find(doc => doc.soundex === soundexMaisParecido.bestMatch.target)
            return docEncontrado.id
        },
        limparNomeArquivo(nomeAnexo) {
            const nomeSemNumeros = nomeAnexo.replace(/[0-9]/g, '')
            const qtdCaracteresNomeArquivo = nomeSemNumeros.length - Math.abs(nomeSemNumeros.length - nomeSemNumeros.lastIndexOf('.'))
            return nomeSemNumeros.substr(0, qtdCaracteresNomeArquivo)
        },
        extensaoArquivoValida(nomeArquivo) {
            const extensao = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'), nomeArquivo.length)
            return extensao === '.pdf' || extensao === '.PDF'
        },
        tratarEventDownloadAnexo(tipoDownload, anexo){
            const payload = {
                tipoDownload: tipoDownload,
                anexo: anexo,
            }
            this.$emit('downloadAnexo', payload)
        },

        //TODO nova forma de upload de arquivo. Remover depois da atualização do LOKI
        async tratarEventUploadArquivo(event){
            if (!this.extensaoArquivoValida(event.filename)) {
                this.mostrarNotificacaoErro('Extensão do arquivo inválida. Por favor, faça upload de um arquivo .pdf')
                this.resetUploadedFiles()
            } else {
                const {arquivo}  = await this.$store.dispatch(actionTypes.UPLOAD_ARQUIVO_SEM_LOKI, event.formData)
                this.adicionarAnexoCarregado(arquivo)
            }
        },
        adicionarAnexoCarregado(arquivo) {
            if(arquivo){

                const file = {
                    nome: arquivo.nome,
                    uri: arquivo.uri,
                    documentoId: this.inferirTipoAnexo(arquivo.nome)
                }
                this.$emit('adicionarAnexo', file)
            }
            this.resetUploadedFiles()
        },
        deveMostrarBotaoDownload(item){
            return (item.id && item.uri) || (item.id && item.idVirtualizado)
        }
    },
    filters: {
        documentoFilter(docId, documentos) {
            const documentosEncontados = documentos.filter(doc => doc.id === docId)
            if (documentosEncontados.length > 0) {
                return documentosEncontados[0].nome
            }
            return ''
        }
    }
}
</script>

<style scoped lang="stylus">
    .table-arquivos-consulta
        padding 0 16px 16px

        .v-input
            margin-bottom 8px !important

        tr:last-child
            border-bottom 0 !important

        .table-actions span
            display inline-block
            flex-wrap wrap

        .selecionar-tipo
            display flex
            align-items center
            flex-wrap wrap

            div[role='combobox']
                width 60%

            .v-btn
                min-width 20px
                background-color #fff

            .mensagem-erro
                width 100%

    a.botao-adicionar-arquivo
        background-color var(--v-primary-base) !important
        border 1px solid var(--v-primary-base) !important
        padding 10px 15px

    a.botao-adicionar-arquivo:hover, a.botao-adicionar-arquivo:active, a.botao-adicionar-arquivo:focus
        background-color var(--v-primary-lighten1) !important
        border 1px solid var(--v-primary-lighten1) !important
        color: white !important

    a.botao-adicionar-arquivo i
        font-size 20px

    @media (max-width 720px)
        .table-arquivos-consulta
            padding 0

            td:nth-of-type(1)
                width 100%

            td:nth-of-type(1):before
                content "Tipo:"

            td:nth-of-type(2):before
                content "Data:"

            td:nth-of-type(3):before
                content "Nome:"

            td:nth-of-type(4):before
                content "Situação:"

            td:nth-of-type(5):before
                display none
</style>
